import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { MapPin, Navigation } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface GPSTrackingToggleProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
  isTracking: boolean;
  lastPosition: { lat: number; lng: number } | null;
}

export const GPSTrackingToggle = ({
  isEnabled,
  onToggle,
  isTracking,
  lastPosition,
}: GPSTrackingToggleProps) => {
  const { t } = useTranslation();

  return (
    <Card className="border-[#87ADD4]">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Navigation className="h-5 w-5 text-[#0880AE]" />
            <CardTitle className="text-lg">Suivi GPS en temps réel</CardTitle>
          </div>
          {isTracking && (
            <Badge className="bg-[#14A38B] text-white">
              Actif
            </Badge>
          )}
        </div>
        <CardDescription>
          Partager votre position GPS pendant la mission
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="gps-tracking" className="flex items-center gap-2 cursor-pointer">
            <MapPin className="h-4 w-4 text-[#5A6B7A]" />
            <span>Activer le suivi GPS</span>
          </Label>
          <Switch
            id="gps-tracking"
            checked={isEnabled}
            onCheckedChange={onToggle}
          />
        </div>

        {lastPosition && (
          <div className="p-3 rounded-lg bg-[#EBF4F8] text-sm">
            <p className="text-[#5A6B7A] mb-1">Dernière position connue :</p>
            <p className="text-[#2D3748] font-mono text-xs">
              {lastPosition.lat.toFixed(6)}, {lastPosition.lng.toFixed(6)}
            </p>
          </div>
        )}

        {isEnabled && !isTracking && (
          <p className="text-xs text-[#F2AC57]">
            En attente du signal GPS...
          </p>
        )}
      </CardContent>
    </Card>
  );
};
